module.exports = __webpack_public_path__ + "static/media/SoundWaves.d3256fb4.svg";